import request from 'local_modules/request'
import { reducers, getState } from 'redux/core'
import { constants } from 'helpers'


const setFetching = (isFetching) => reducers.marketplace.cashierLearnPage.setFetching(isFetching)

const fetchLearnList = () => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.cashierLearnList + `/${tool}`)
    .then(({ data }) => data)
    .then((learnList) => reducers.marketplace.cashierLearnPage.setLearnList(learnList))
    .catch((error) => console.log(error))
}

const setLearnListItem = (orderId) => {
  return request.post(constants.marketplace.cashierLearnListUse + `/${orderId}`, {})
    .then(({ data }) => data)
}


export default {
  setFetching,
  fetchLearnList,
  setLearnListItem,
}
